module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(_vm.healthCheckResponse) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-246bd4b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HealthCheck.vue
// module id = 2119
// module chunks = 1